import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { GeneratedCover } from '../components/ui/GeneratedCover';
import { listBooks } from '../services/api';
import { GENRES } from '../services/genres';

export const GenrePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [books, setBooks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const genre = GENRES.find(g => g.slug === slug);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await listBooks(slug ? { genre: slug } : undefined);
        setBooks(res.books || []);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  return (
    <div className="pb-24 px-6 pt-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-xs uppercase tracking-wider opacity-40">Genre</p>
          <h1 className="text-2xl font-serif font-bold capitalize">{genre?.name || slug}</h1>
          {genre?.desc && <p className="text-sm opacity-60">{genre.desc}</p>}
        </div>
      </div>

      {loading && <p className="text-sm opacity-60">Loading...</p>}
      {error && <p className="text-sm text-red-500">{error}</p>}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {books.map(book => (
          <Link key={book.id} to={`/book/${book.id}`} className="group">
            <GeneratedCover title={book.title} author={book.author} genre={book.genre} size="md" className="w-full h-auto aspect-[2/3] mb-2 shadow-sm" />
            <p className="font-serif font-bold text-sm leading-tight group-hover:text-brand-blue">{book.title}</p>
            <p className="text-xs opacity-60">{book.author}</p>
          </Link>
        ))}
      </div>
      {!loading && books.length === 0 && <p className="text-sm opacity-60 mt-6">No books in this genre yet.</p>}
    </div>
  );
};
